
export interface PendingTransaction {
    paymentId: string;
    itemType: 'token' | 'subscription';
    itemId: string;
    dcoinAmount?: number;
    timestamp: number;
}

const KEY = 'dmat_pending_transactions';

export const getPendingTransactions = (): PendingTransaction[] => {
    try {
        const data = localStorage.getItem(KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        return [];
    }
};

export const savePendingTransaction = (tx: PendingTransaction) => {
    const existing = getPendingTransactions();
    // Avoid duplicates
    if (!existing.some(t => t.paymentId === tx.paymentId)) {
        existing.push(tx);
        localStorage.setItem(KEY, JSON.stringify(existing));
    }
};

export const removePendingTransaction = (paymentId: string) => {
    const existing = getPendingTransactions();
    const filtered = existing.filter(t => t.paymentId !== paymentId);
    localStorage.setItem(KEY, JSON.stringify(filtered));
};
